import ServiceBookNow from './ServiceBookNow';
import ServiceBookNowTrigger from './ServiceBookNowTrigger';

export { ServiceBookNowTrigger };
export default ServiceBookNow;
